<template>
  <el-dialog
    :model-value="visible"
    @close="$emit('close')"
    class="quick-client-dialog"
    title="Создать нового клиента"
    width="400px"
    destroy-on-close
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="formRef"
      label-width="90px"
      status-icon
      label-position="right"
    >
      <el-form-item label="ФИО" prop="fio" required>
        <el-input
          v-model="form.fio"
          ref="fioInput"
          autocomplete="off"
          @blur="onFioBlur"
        />
      </el-form-item>
      <el-form-item label="Телефон" prop="phone" required>
        <PhoneInput v-model:phone="form.phone" ref="phoneInput" @is-complete="handlePhoneComplete" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('close')">Отмена</el-button>
      <el-button type="primary" @click="onSave">Создать</el-button>
    </template>
  </el-dialog>
</template>

<script>
import PhoneInput from '@/components/util/PhoneInput.vue'

export default {
  name: 'QuickClientCreate',
  components: { PhoneInput },
  props: {
    visible: Boolean,
    cityId: Number,
    defaultFio: { type: String, default: '' },
    defaultPhone: { type: String, default: '' }
  },
  data() {
    return {
      form: {
        fio: this.defaultFio || '',
        phone: this.defaultPhone || '',
      },
      isPhoneComplete: false,
      rules: {
        fio: [{ required: true, message: 'Укажите ФИО', trigger: 'blur' }],
        phone: [{ required: true, message: 'Введите телефон', trigger: 'blur' }]
      }
    }
  },
  watch: {
    defaultFio(val) { this.form.fio = this.formatFio(val) },
    defaultPhone(val) { this.form.phone = val },
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            // Всегда форматируем ФИО при открытии
            this.form.fio = this.formatFio(this.form.fio)
            const cleanedPhone = (this.form.phone || '').replace(/\D/g, '');
            // Если пользователь искал по имени или телефон неполный — фокус на ФИО
            if (this.form.fio && (!cleanedPhone || cleanedPhone.length < 11)) {
              if (this.$refs.fioInput?.focus) {
                this.$refs.fioInput.focus();
              }
            } else {
              if (this.$refs.phoneInput?.focus) {
                this.$refs.phoneInput.focus();
              }
            }
          }, 200);
        });
      }
    }
  },
  methods: {
    handlePhoneComplete(isComplete) {
      this.isPhoneComplete = isComplete
    },
    onSave() {
      if (!this.isPhoneComplete) {
        this.$message.error('Пожалуйста, введите полный номер телефона')
        return
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // Вернуть только нужное!
          this.$emit('save', {
            fio: this.form.fio,
            phone: this.form.phone
          })
        }
      })
    },
    formatFio(fio) {
      if (!fio) return '';
      return fio
        .split(' ')
        .filter(Boolean)
        .map(word => word[0] ? word[0].toUpperCase() + word.slice(1).toLowerCase() : '')
        .join(' ');
    },
    onFioBlur() {
      this.form.fio = this.formatFio(this.form.fio);
    }
  }
}
</script>

<style>
.quick-client-dialog.el-dialog {
  width: min(390px, calc(100vw - 24px)) !important;
  border-radius: 18px !important;
  background:
    linear-gradient(rgba(0, 108, 254, 0.14), rgba(0, 108, 254, 0.14)),
    linear-gradient(299deg, #030b1b 13.22%, #15264e 86.78%) !important;
  border: 1px solid rgba(63, 111, 184, 0.55) !important;
  box-shadow: 0 18px 42px rgba(0, 6, 19, 0.44) !important;
}

.quick-client-dialog .el-dialog__header {
  padding: 16px 20px 2px !important;
  margin: 0 !important;
}

.quick-client-dialog .el-dialog__title {
  display: block !important;
  color: #ffffff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 19px !important;
  font-weight: 400 !important;
  line-height: 1.1 !important;
}

.quick-client-dialog .el-dialog__headerbtn {
  top: 13px !important;
  right: 18px !important;
  width: 22px !important;
  height: 22px !important;
  z-index: 3 !important;
}

.quick-client-dialog .el-dialog__close,
.quick-client-dialog .el-dialog__close svg,
.quick-client-dialog .el-dialog__close svg path {
  color: rgba(182, 206, 255, 0.82) !important;
  fill: rgba(182, 206, 255, 0.82) !important;
}

.quick-client-dialog .el-dialog__body {
  padding: 4px 18px 8px !important;
}

.quick-client-dialog .el-dialog__footer {
  padding: 4px 18px 14px !important;
}

.quick-client-dialog .el-form-item {
  margin-bottom: 12px !important;
}

.quick-client-dialog .el-form-item__label {
  color: #ffffff !important;
  font-size: 15px !important;
  line-height: 38px !important;
  height: 38px !important;
}

.quick-client-dialog .el-input__wrapper,
.quick-client-dialog .vue-tel-input {
  min-height: 38px !important;
  height: 38px !important;
  background: #254c90 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
}

.quick-client-dialog .el-input__inner,
.quick-client-dialog .vti__input {
  color: #22c0ff !important;
  font-size: 14px !important;
  line-height: 38px !important;
}

.quick-client-dialog .el-button {
  min-height: 32px !important;
  border-radius: 4px !important;
  padding: 0 18px !important;
}

@media (max-width: 480px) {
  .quick-client-dialog.el-dialog {
    width: calc(100vw - 18px) !important;
  }

  .quick-client-dialog .el-dialog__body,
  .quick-client-dialog .el-dialog__footer {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
}
</style>
